export default "__VITE_ASSET__KYLWX07$__"